import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { TransitionTrigger } from './transition-trigger';

export class EnrolmentQualifiedTrigger extends TransitionTrigger {
	public orderingNumber = 31;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Qualified', excludedEnrolmentStatuses);
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentQualifiedTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>): Promise<void> {
		await EnrolmentService.triggerEnrolmentQualified(enrolments);
	}
}
